module.exports = {
	"articleTitle1": "Best Salad: Salad's UP! ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Salad's Up",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/new-fast-salad-restaurant-brings-fresh-taste-table",
	"articleSnippet1": "Apr 2, 2017 ... When it comes to convenience, portions, affordability and location, Salad's UP! is \nthe plant-lover's dream and the health nut's constant craving.",
	"articleSnippet2": "Dec 12, 2014 ... Salads UP — a locally focused, quick salad restaurant — opened last Tuesday \non East Liberty Street. Created by University alums Robert ...",
	"foodRecommendations": [],
	"articleTitle2": "Salads Up",
	"address": "611 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/mer.NEW_.BOAA-Salads%20Up%20and%20Brueggers%20Bagels031.jpg?itok=ICHXxnXz",
			"author": "Marina Ross",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279525,
		"lng": -83.741477
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/saladsup.json
// module id = 966
// module chunks = 0